import React, { useEffect } from 'react';
import { useStore, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import * as actionTypes from '../@Redux/actionTypes';
import OverlayModal from '../common/overlayModal';
import { eventDispatcher } from '../../../components/common/Tagging';

const PerkDisclosureModal = () => {
  const state = useStore().getState();
  const dispatch = useDispatch();
  useEffect(() => {
    if (show) {
      const obj = { name: `${overlayHeadline} modal` };
      eventDispatcher('openView', obj);
    }
  }, []);
  const { currentSpoId = '', show = false } = state?.progressivePlans?.perkDisclosureOverlay || {};
  const { duplicatePerkOverlay = {} } = state?.plansReferenceData?.output || {};
  if (currentSpoId === '') return;
  const { overlayHeadline = '', overlayDescription = '' } = state?.progressivePlans?.perkDetails?.perks?.[`${currentSpoId}${'_FWA'}`]?.data || {};
  const modalData = {
    title: overlayHeadline,
    description: overlayDescription,
    primaryBtnText: duplicatePerkOverlay.gotDuplicateButton,
    closeBtnText: '',
    onModalCloseHandler: () => {
      dispatch({
        type: actionTypes.UPDATE_PERK_DISCLOSURE,
        response: {
          ...state?.progressivePlans?.perkDisclosureOverlay,
          show: false,
        },
      });
    },
    isOpened: show,
  };

  return <OverlayModal {...modalData} />;
};

PerkDisclosureModal.propTypes = {
  modalArrgs: PropTypes.object,
};

export default PerkDisclosureModal;
